import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const loginGoogle = async (
    data: AccountModel.PostLoginGoogleRequest
): Promise<AccountModel.PostLoginResponse> => {
    let response: AccountModel.PostLoginResponse;
    try {
        response = await Http.Request<AccountModel.PostLoginResponse>({
            method: "POST",
            url: "/account/loginGoogle",
            data,
        });
    } catch (error) {
        throw Error(error);
        // @todo add user error handler
    }
    return response;
};

export default loginGoogle;
